export const systemRolesOrder = {
  Admin: 1,
  Manager: 2,
  'Head Of Discipline': 3,
  Lead: 4,
  Endavan: 5
}

/**
 * @typedef {Object} SortOrder
 * @property {"asc" | "dsc"} order
 */

/**
 * @typedef {Object} SortState
 * @property {SortOrder} roles
 * @property {SortOrder} users
 */

/**
 * @typedef {Object} Role
 * @property {number | undefined} systemRoleOrder
 * @property {number} assignedUsersCount
 * @property {string} name
 */

/**
 * @param {Role[]} roles
 * @param {SortState} sortState
 * @returns {Role[]}
 */
export const sortRoles = (roles, sortState) => {
  const sortedRoles = roles.sort((roleA, roleB) => {
    if (roleA?.systemRoleOrder && roleB?.systemRoleOrder) {
      return roleA.systemRoleOrder - roleB.systemRoleOrder
    }

    if (roleA?.systemRoleOrder) {
      return -1
    }
    if (roleB?.systemRoleOrder) {
      return 1
    }

    if (sortState?.roles) {
      const order = sortState.roles.order === 'asc' ? 1 : -1
      return roleA.name.localeCompare(roleB.name) * order
    }

    if (sortState?.users) {
      const order = sortState.users.order === 'asc' ? 1 : -1
      return (roleA.assignedUsersCount - roleB.assignedUsersCount) * order
    }
  })

  return sortedRoles
}
